<template>
    <thead>
        <tr>
            <th colspan="54">Non-Drinkware Summary</th>
        </tr>
        <tr class="table-titles">
            <th colspan="2">Date</th>
            <th colspan="2"><img src="@/assets/images/apron.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/tee.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/dtg-shirt.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/leggings.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/skirt.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/face mask.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/oven mitts.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/socks.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/tote bag.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/necklace.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/lunch bag.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/desk mat.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/mouse pad.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/blanket.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/pillow.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/pillow-filled.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/coasters.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/ornament.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/storage box.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/canvas.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/phone-case.svg" alt="" /></th>
            <th colspan="2"><img src="@/assets/images/keychain.svg" alt="" /></th>
            <th colspan="2">
                <img src="@/assets/images/table cloth.svg" alt="" />
            </th>

            <th colspan="2">TOTAL ORDERS</th>
        </tr>
        <tr class="item-action">
            <th colspan="2"></th>
            <th class="in border-left" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
            <th class="in" colspan="1">IN</th>
            <th class="out" colspan="1">LEFT</th>
        </tr>
    </thead>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
    name: "TitleTableNDW",
    components: {}
});
</script>

<style lang="scss" scoped>

</style>